<!--
  - Copyright (c) 2019 Eva Novotná, Juraj Šimon
  -->

<template>
  <div class="footer level">
    <div class="level-left">
      <div class="copyright level-item">
        Copyright 2019 Eva Novotná
      </div>
    </div>
    <a class="level-left" href="#top" v-smooth-scroll="{ duration: 800 }">
      <div class="level-item scroll-to-top">
        <up-arrow /> {{ $t("Scroll to top") }}
      </div>
    </a>
  </div>
</template>
<script>
import upArrow from "./../assets/keyboard_arrow_up-24px.svg";
export default {
  methods: {},
  components: {
    upArrow
  }
};
</script>
<style lang="scss" scoped>
@import "section";

.footer {
  width: 100%;
  font-size: 0.9rem;
  background-color: $secondary-background-color;

  .copyright {
    padding: 0 0 0 $general-padding-on-sides;

    @include mobile {
      padding: $general-padding-on-sides-mobile 0 0
        $general-padding-on-sides-mobile;
    }
  }

  .scroll-to-top {
    padding: 1rem $general-padding-on-sides 1rem 0;
    display: flex;
    align-items: center;

    @include mobile {
      padding: 1rem $general-padding-on-sides-mobile 1rem 0;
    }
  }
}

a {
  color: black;
}
</style>
